// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__bURF2","section__background":"section_section__background__gY0_0","section__components":"section_section__components__zx46L"};